/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.banner {
  position: relative;
  padding-block: calc(var(--spacing, 0.25rem) * 4);
  padding-left: calc(var(--spacing, 0.25rem) * 6);
  padding-right: calc(var(--spacing, 0.25rem) * 16);
  top: 0px;
  left: 0px;
  width: 100%;
}
.banner.WARNING {
  color: var(--color-warning-dark, #c2410c);
  background-color: var(--color-warning-light, #ffedd5);
}
.banner.ERROR {
  background-color: var(--color-danger-light, #fef2f2);
  color: var(--color-danger-dark, #b91c1c);
}
.banner.NEUTRAL {
  background-color: var(--color-gray-200, #e5e5e5);
  color: var(--color-emphasis-high, #000);
}
.text {
  text-align: center;
  padding-inline: calc(var(--spacing, 0.25rem) * 4);
  width: 100%;
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
}
.closeLink {
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
  position: absolute;
  top: calc(var(--spacing, 0.25rem) * 3);
  right: calc(var(--spacing, 0.25rem) * 4);
  --tw-border-style: none;
  border-style: none;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-font-weight: initial;
    }
  }
}
